import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeIntegerBaseComponent } from './e5core-ui-work-field-type-integer-base';

@Component({
  selector: 'e5core-ui-work-field-type-integer-bootstrap',
  templateUrl: './e5core-ui-work-field-type-integer-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-integer-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeIntegerBootstrapComponent extends E5coreUiWorkFieldTypeIntegerBaseComponent {
}
